import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f74dbb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "balances-list-exchange-mobile" }
const _hoisted_2 = {
  key: 1,
  class: "balances-list-exchange-mobile__content"
}
const _hoisted_3 = { class: "balance-item-mobile__header" }
const _hoisted_4 = { class: "balance-item-mobile__currency-info" }
const _hoisted_5 = { class: "balance-item-mobile__code-wrapper" }
const _hoisted_6 = { class: "balance-item-mobile__code" }
const _hoisted_7 = { class: "balance-item-mobile__name" }
const _hoisted_8 = { class: "balance-item-mobile__actions" }
const _hoisted_9 = { class: "balance-item-mobile__details" }
const _hoisted_10 = { class: "balance-item-mobile__column" }
const _hoisted_11 = { class: "balance-item-mobile__row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "balance-item-mobile__label" }, "Net:", -1))
const _hoisted_13 = { class: "balance-item-mobile__value" }
const _hoisted_14 = { class: "balance-item-mobile__row" }
const _hoisted_15 = { class: "balance-item-mobile__label" }
const _hoisted_16 = { class: "balance-item-mobile__value" }
const _hoisted_17 = { class: "balance-item-mobile__column" }
const _hoisted_18 = { class: "balance-item-mobile__row" }
const _hoisted_19 = { class: "balance-item-mobile__label" }
const _hoisted_20 = { class: "balance-item-mobile__value" }
const _hoisted_21 = { class: "balance-item-mobile__row" }
const _hoisted_22 = { class: "balance-item-mobile__label" }
const _hoisted_23 = { class: "balance-item-mobile__value" }

import { OtIcon } from '@1trading/design-system';
import type { PropType } from 'vue';

import type { BalanceModel } from '@exchange/libs/balances/service/src';
import XLogo from '@exchange/libs/components/x-components/src/lib/XLogo.vue';
import { marginService } from '@exchange/libs/futures/service/src';
import { CURRENCY_ELIGIBLE_FOR_MARGIN } from '@exchange/libs/futures/service/src/lib/constants.config';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { currencyService } from '@exchange/libs/utils/currency/src';

import BalancesInfoMessageBlock from './BalancesInfoMessageBlock.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BalancesListExchangeMobile',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  historySource: { type: Object as PropType<HistoryDataSource>, required: true },
  sortedList: { type: Array as PropType<BalanceModel[]>, required: true },
},
  emits: ["search:search-start", "search:search-end", "deposit", "transfer"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const { getCurrencyName } = currencyService;
const { balance: marginBalance, equity, marginUsedPercentage } = marginService;

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.sortedList.length || !__props.authenticatedUser)
      ? (_openBlock(), _createBlock(BalancesInfoMessageBlock, {
          key: 0,
          "authenticated-user": __props.authenticatedUser
        }, null, 8, ["authenticated-user"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sortedList, (balance) => {
            return (_openBlock(), _createElementBlock("div", {
              key: balance.currencyCode,
              class: "balance-item-mobile"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(XLogo, {
                    class: "balance-item-mobile__icon",
                    name: balance.currencyCode,
                    type: "crypto"
                  }, null, 8, ["name"]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(balance.currencyCode), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getCurrencyName)(balance.currencyCode)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_x_button, {
                    class: "balance-item-mobile__action-button",
                    size: "3xs",
                    variant: "tertiary",
                    onClick: () => emit('deposit', balance.currencyCode)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OtIcon), { name: "add-square" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_x_button, {
                    class: "balance-item-mobile__action-button",
                    size: "3xs",
                    variant: "tertiary",
                    onClick: () => emit('transfer', balance.currencyCode)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(OtIcon), { name: "arrow-swap-horizontal" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(equity).toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.total), 1),
                      _createTextVNode(" / "),
                      _createVNode(_component_ot_number_display, {
                        class: "balance-item-mobile__value",
                        grouping: true,
                        prefix: "€",
                        number: balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(equity) : balance.totalFiatValue,
                        precision: 2
                      }, null, 8, ["number"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('modules.myOrders.header.availableMargin')) + ":", 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginBalance).available.toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.available), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('modules.myOrders.header.usedMargin')) + ":", 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginBalance).used.toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.locked), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('modules.myOrders.header.usedForMargin')) + ":", 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginUsedPercentage) + '%' : '0%'), 1)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
  ]))
}
}

})